// Govin 2.3.1: Broadcast feature configuration
// Default password for master mode (teacher access)
// Change this password to secure your classroom broadcast feature
export const MASTER_PASSWORD = 'Govin@2025'; // Default password - change for production

// WebSocket server configuration
export const DEFAULT_PORT = 8765;
export const DEFAULT_HOST = '0.0.0.0'; // Listen on all interfaces
